(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro-ugc-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ugc-video-grid").forEach(grid => {
    const items = grid.querySelectorAll(".ugc-item");

    items.forEach(item => {
      item.addEventListener("click", () => {
        // Reset
        items.forEach(i => {
          i.classList.remove("active");
          const v = i.querySelector("video");
          if (v) {
            v.pause();
            v.currentTime = 0;
          }
        });

        // Aktives Video starten
        item.classList.add("active");
        const v = item.querySelector("video");
        if (v) v.play();
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layering"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const productNames = document.querySelectorAll('.product-name');
  const products = document.querySelectorAll('.layering-product');
  const productTextWrapper = document.querySelector('.product-text-wrapper');
  const underline = document.querySelector('.underline');

  productNames.forEach((name, index) => {
    name.addEventListener('click', function() {
      // Remove active state from all product names and products
      productNames.forEach(n => n.classList.remove('active'));
      products.forEach(p => p.classList.remove('active'));

      // Add fade-out class to the previous product

      // Add fade-in class to the current product
      name.classList.add('active');
      products[index].classList.add('active');

      // Update the underline position
      const nameWidth = name.offsetWidth;
      const nameLeft = name.offsetLeft;
      underline.style.width = `${nameWidth}px`;
      underline.style.left = `${nameLeft}px`;

      // Display the text associated with the clicked product
      const productText = name.getAttribute('data-text');
      productTextWrapper.textContent = productText || '';

    });
  });

  // Trigger default active state
  productNames[0].click();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiles-reloaded"] && !Shopify.designMode) return;
  try {
    
function setupCarousel(carouselContainer) {
  const carousel = carouselContainer;
  const images = carousel.querySelectorAll('.carousel-reloaded-item');
  const chevronRight = carousel.querySelector('.carousel-reloaded--chevron-right');
  const chevronLeft = carousel.querySelector('.carousel-reloaded--chevron-left');

  const imagesCount = images.length;
  let currentIndex = 0;
  let touchStartX = 0;
  let touchStartY = 0;
  let isSwiping = false;

function moveToImage(index) {
    currentIndex = index;
    images.forEach((image, i) => {
      if (i === currentIndex) {
        image.classList.add('active');
      } else {
        image.classList.remove('active');
      }
    });

    const nav = carousel.querySelector('.carousel-reloaded-nav');
    const navWidth = (100 / imagesCount);
    const navPos = (100 / imagesCount) * currentIndex;
    if (nav) {
      nav.style.width = `${navWidth}%`;
      nav.style.left = `${navPos}%`;
    }
}

function handleTouchStart(e) {
  touchStartX = e.touches[0].clientX;
  touchStartY = e.touches[0].clientY;
  isSwiping = false;
}

function handleTouchMove(e) {
  const touchEndX = e.touches[0].clientX;
  const touchEndY = e.touches[0].clientY;

  const horizontalDistance = Math.abs(touchEndX - touchStartX);
  const verticalDistance = Math.abs(touchEndY - touchStartY);

  // Check if the horizontal distance is greater than the vertical distance
  if (horizontalDistance > verticalDistance) {
    e.preventDefault();
    isSwiping = true;
  } else {
    // Allow vertical scrolling
    isSwiping = false;
  }
}

function handleTouchEnd(e) {
    const touchEndX = e.changedTouches[0].clientX;
    const touchDiff = touchStartX - touchEndX;

    if (Math.abs(touchDiff) > 50 && isSwiping) {
      if (touchDiff > 0) {
        swipeCarousel({ type: 'swipeleft' });
      } else {
        swipeCarousel({ type: 'swiperight' });
      }
    }
    if (e.target.className === 'carousel-reloaded--chevron-left') {
        swipeCarousel({ type: 'swiperight' });
    } else if (e.target.className === 'carousel-reloaded--chevron-right') {
        swipeCarousel({ type: 'swipeleft' });
    }
    isSwiping = false;
}

function handleMouseDown(e) {
    touchStartX = e.clientX;
    touchStartY = e.clientY;
    isSwiping = false;
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
}

function handleMouseMove(e) {
    e.preventDefault();
    e.stopPropagation();

    const touchEndX = e.clientX;
    const touchEndY = e.clientY;

    const horizontalDistance = Math.abs(touchEndX - touchStartX);
    const verticalDistance = Math.abs(touchEndY - touchStartY);

    // Check if the horizontal distance is greater than the vertical distance
    if (horizontalDistance > verticalDistance) {
      isSwiping = true;
    } else {
      // Allow vertical scrolling
      isSwiping = false;
    }
}

  function handleMouseUp(e) {
    const touchEndX = e.clientX;
    const touchDiff = touchStartX - touchEndX;

    if (Math.abs(touchDiff) > 50 && isSwiping) {

        e.preventDefault();
        e.stopPropagation();
      if (touchDiff > 0) {
        swipeCarousel({ type: 'swipeleft' });
      } else {
        swipeCarousel({ type: 'swiperight' });
      }
    }

    isSwiping = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  }

  function swipeCarousel(e) {
    if (e.type === 'swipeleft') {
      currentIndex = (currentIndex + 1) % imagesCount;
    } else if (e.type === 'swiperight') {
      currentIndex = (currentIndex - 1 + imagesCount) % imagesCount;
    }
    moveToImage(currentIndex);
  }
  
  var supportsPassive2 = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
        get: function() {
            supportsPassive2 = true;
        }
    });
    window.addEventListener("testPassive", null, opts);
    window.removeEventListener("testPassive", null, opts);
  } catch (e) {}
  
  carousel.addEventListener('touchstart', handleTouchStart, supportsPassive2 ? { passive: true } : false);
  carousel.addEventListener('touchmove', handleTouchMove, supportsPassive2 ? { passive: true } : false);
  carousel.addEventListener('touchend', handleTouchEnd, supportsPassive2 ? { passive: true } : false);

  carousel.addEventListener('mousedown', handleMouseDown);
  if (chevronLeft && chevronRight) { 
    chevronLeft.addEventListener('mouseup', swipeCarousel('swipeleft'));
    chevronRight.addEventListener('mouseup', swipeCarousel('swiperight'));
    chevronLeft.addEventListener('touchend', swipeCarousel('swipeleft'));
    chevronRight.addEventListener('touchend', swipeCarousel('swiperight'));
  }

  moveToImage(0); // Initialize the carousel with the first image
}

document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth < 769) {
      const carouselsReloaded = document.querySelectorAll('.carousel-reloaded-container');
      carouselsReloaded.forEach(setupCarousel);
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiles"] && !Shopify.designMode) return;
  try {
    
function setupCarousel(carouselContainer) {
  const carousel = carouselContainer;
  const images = carousel.querySelectorAll('.carousel-item');
  const imagesCount = images.length;
  let currentIndex = 0;
  let touchStartX = 0;
  let touchStartY = 0;
  let isSwiping = false;

  function moveToImage(index) {
    currentIndex = index;
    images.forEach((image, i) => {
      if (i === currentIndex) {
        image.classList.add('active');
      } else {
        image.classList.remove('active');
      }
    });

    const nav = carousel.querySelector('.carousel-nav');
    const navWidth = (100 / imagesCount);
    const navPos = (100 / imagesCount) * currentIndex;
    nav.style.width = `${navWidth}%`;
    nav.style.left = `${navPos}%`;
  }

  function handleTouchStart(e) {
  touchStartX = e.touches[0].clientX;
  touchStartY = e.touches[0].clientY;
  isSwiping = false;
}

function handleTouchMove(e) {
  const touchEndX = e.touches[0].clientX;
  const touchEndY = e.touches[0].clientY;

  const horizontalDistance = Math.abs(touchEndX - touchStartX);
  const verticalDistance = Math.abs(touchEndY - touchStartY);

  // Check if the horizontal distance is greater than the vertical distance
  if (horizontalDistance > verticalDistance) {
    e.preventDefault();
    isSwiping = true;
  } else {
    // Allow vertical scrolling
    isSwiping = false;
  }
}

  function handleTouchEnd(e) {
    const touchEndX = e.changedTouches[0].clientX;
    const touchDiff = touchStartX - touchEndX;

    if (Math.abs(touchDiff) > 50 && isSwiping) {
      if (touchDiff > 0) {
        swipeCarousel({ type: 'swipeleft' });
      } else {
        swipeCarousel({ type: 'swiperight' });
      }
    }

    isSwiping = false;
  }

  function handleMouseDown(e) {
    touchStartX = e.clientX;
    touchStartY = e.clientY;
    isSwiping = false;
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }

  function handleMouseMove(e) {
    e.preventDefault();
    
    const touchEndX = e.clientX;
    const touchEndY = e.clientY;
  
    const horizontalDistance = Math.abs(touchEndX - touchStartX);
    const verticalDistance = Math.abs(touchEndY - touchStartY);
  
    // Check if the horizontal distance is greater than the vertical distance
    if (horizontalDistance > verticalDistance) {
      e.preventDefault();
      isSwiping = true;
    } else {
      // Allow vertical scrolling
      isSwiping = false;
    }
  }

  function handleMouseUp(e) {
    const touchEndX = e.clientX;
    const touchDiff = touchStartX - touchEndX;

    if (Math.abs(touchDiff) > 50 && isSwiping) {
      if (touchDiff > 0) {
        swipeCarousel({ type: 'swipeleft' });
      } else {
        swipeCarousel({ type: 'swiperight' });
      }
    }

    isSwiping = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  }

  function swipeCarousel(e) {
    if (e.type === 'swipeleft') {
      currentIndex = (currentIndex + 1) % imagesCount;
    } else if (e.type === 'swiperight') {
      currentIndex = (currentIndex - 1 + imagesCount) % imagesCount;
    }
    moveToImage(currentIndex);
  }

  carousel.addEventListener('touchstart', handleTouchStart);
  carousel.addEventListener('touchmove', handleTouchMove);
  carousel.addEventListener('touchend', handleTouchEnd);

  carousel.addEventListener('mousedown', handleMouseDown);

  moveToImage(0); // Initialize the carousel with the first image
}
  // Define a click event handler function
function handleAddToCartClick(evt) {
    // Prevent the default behavior of the click event (e.g., navigating to a new page)
    evt.stopPropagation();
  
    evt.preventDefault();
  console.log(1)
        if (status.loading) {
          return;
        }
  
        // Loading indicator on add to cart button
        //this.addToCart.classList.add('btn--loading');
  
        status.loading = true;
  
        var data = $(this).serialize();
  
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            this.error(data);
          } else {
            var product = data;
            this.success(product);
          }
  
          status.loading = false;
          // this.addToCart.classList.remove('btn--loading');
  
        }.bind(this));
}

document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.carousel-container');
  carousels.forEach(setupCarousel);

var addToCartButtons = document.querySelectorAll('.tiles--buy-now');

// Add the click event listener to each "Add to Cart" button
addToCartButtons.forEach(function(button) {
    button.addEventListener('submit', handleAddToCartClick);
});
});

  } catch(e) { console.error(e); }
})();
})();
